import { Record } from "immutable";

export const TICKETING_INTEGRATIONS = ["jira", "jira-service-management", "zendesk"] as const;
export type TTicketingIntegrationType = (typeof TICKETING_INTEGRATIONS)[number];

const defaults = {
  assigneeId: null as null | string,
  euid: "",
  id: "",
  isDeleted: false,
  name: "",
  projectEuid: "",
  projectName: "",
  publicEuid: "",
  status: "",
  ticketingIntegration: "" as "" | TTicketingIntegrationType,
  url: "",
};

export class TicketingIntegrationTicketModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown): TicketingIntegrationTicketModel {
    const { assigneeId, euid, id, integration, isDeleted, name, projectEuid, projectName, publicEuid, status, url } =
      data as Omit<typeof defaults, "ticketingIntegration"> & { integration: null | { type: TTicketingIntegrationType } };

    return new TicketingIntegrationTicketModel({
      assigneeId,
      euid,
      id,
      isDeleted,
      name,
      projectEuid,
      projectName,
      publicEuid,
      status,
      ticketingIntegration: integration?.type ?? "",
      url,
    });
  }
}
